import React from "react";

/** Semantic status → { dot color, tint bg, border, text }. */
const STATUS_TOKENS = {
  // positive / active
  available:        { c: "var(--brand-lime)", tone: "ready" },
  touring:          { c: "var(--brand-lime)", tone: "ready" },
  active_tour:      { c: "var(--brand-lime)", tone: "ready" },
  completed:        { c: "var(--fg-muted)",   tone: "neutral" },
  // pipeline / info
  inquiry:          { c: "var(--fg-muted)",   tone: "neutral" },
  booked:           { c: "var(--brand-blue)", tone: "info" },
  dispatched:       { c: "var(--brand-blue)", tone: "info" },
  dispatch_ready:   { c: "var(--brand-blue)", tone: "info" },
  // holds → amber
  soft_hold:        { c: "var(--status-hold)", tone: "hold" },
  first_hold:       { c: "var(--status-hold)", tone: "hold" },
  second_hold:      { c: "var(--status-hold)", tone: "hold" },
  contract_pending: { c: "var(--status-hold)", tone: "hold" },
  // maintenance
  maintenance:      { c: "var(--status-maintenance)", tone: "maintenance" },
  shop:             { c: "var(--status-maintenance)", tone: "maintenance" },
  // critical
  out_of_service:   { c: "var(--status-critical)", tone: "critical" },
  inactive:         { c: "var(--fg-muted)", tone: "neutral" },
  owner_use:        { c: "var(--fg-muted)", tone: "neutral" },
};

const TONE_TEXT = {
  ready: "var(--fg-primary)",
  neutral: "var(--fg-secondary)",
  info: "var(--brand-blue)",
  hold: "var(--status-hold)",
  maintenance: "var(--status-maintenance)",
  critical: "var(--status-critical)",
};

const dotStyle = (color) => ({
  display: "inline-block",
  width: 7, height: 7, borderRadius: 999,
  background: color, flexShrink: 0,
});

export const StatusPill = ({ status, className = "" }) => {
  const t = STATUS_TOKENS[status] || { c: "var(--fg-muted)", tone: "neutral" };
  return (
    <span
      data-testid={`status-pill-${status}`}
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-sm text-[11px] font-medium tracking-wide uppercase ${className}`}
      style={{
        background: `color-mix(in srgb, ${t.c} 10%, transparent)`,
        border: `1px solid color-mix(in srgb, ${t.c} 32%, transparent)`,
        color: TONE_TEXT[t.tone] || "var(--fg-primary)",
      }}
    >
      <span style={dotStyle(t.c)} />
      {(status || "unknown").replace(/_/g, " ")}
    </span>
  );
};

const CRED_TOKENS = {
  green:   { c: "var(--brand-lime)",         tone: "ready" },
  amber:   { c: "var(--status-hold)",        tone: "hold" },
  orange:  { c: "var(--status-maintenance)", tone: "maintenance" },
  red:     { c: "var(--status-critical)",    tone: "critical" },
  unknown: { c: "var(--fg-muted)",           tone: "neutral" },
};

export const CredentialChip = ({ level, label, className = "" }) => {
  const t = CRED_TOKENS[level] || CRED_TOKENS.unknown;
  return (
    <span
      data-testid={`cred-chip-${level}`}
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-sm text-[10.5px] font-medium tracking-wide uppercase ${className}`}
      style={{
        background: `color-mix(in srgb, ${t.c} 10%, transparent)`,
        border: `1px solid color-mix(in srgb, ${t.c} 32%, transparent)`,
        color: TONE_TEXT[t.tone] || "var(--fg-primary)",
      }}
    >
      <span style={dotStyle(t.c)} />
      {label}
    </span>
  );
};

export const DemoChip = ({ className = "" }) => (
  <span
    data-testid="demo-chip"
    className={`inline-flex items-center px-1.5 py-0.5 rounded-sm text-[9.5px] font-semibold tracking-widest ${className}`}
    style={{
      background: "color-mix(in srgb, var(--status-hold) 12%, transparent)",
      border: "1px solid color-mix(in srgb, var(--status-hold) 32%, transparent)",
      color: "var(--status-hold)",
    }}
  >
    DEMO
  </span>
);
